import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";

import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";

export default function Yogaday() {

    const [open, setOpen] = useState(false);
    const [slides, setSlides] = useState([]);
    const [index, setIndex] = useState(0);
    
    const openGallery = (images, currentIndex) => {
        setSlides(images.map((img) => ({ src: img })));
        setIndex(currentIndex);
        setOpen(true);
    };

    const galleryYoga = [
    {
      title: "International Yoga Day 2026",
      images: [
        "/img/gallery/yogaday2026/1.jpg",
        "/img/gallery/yogaday2026/2.jpg",
        "/img/gallery/yogaday2026/3.jpg",
        "/img/gallery/yogaday2026/4.jpg",
        "/img/gallery/yogaday2026/5.jpg",
        "/img/gallery/yogaday2026/6.jpg",
        "/img/gallery/yogaday2026/7.jpg",
        "/img/gallery/yogaday2026/8.jpg",
        "/img/gallery/yogaday2026/9.jpg",
        "/img/gallery/yogaday2026/10.jpg",
        "/img/gallery/yogaday2026/11.jpg",
        "/img/gallery/yogaday2026/12.jpg",
      ],
    },
    {
      title: "International Yoga Day 2025",
      images: [
        "/img/gallery/yogaday2025/1.jpg",
        "/img/gallery/yogaday2025/2.jpg",
        "/img/gallery/yogaday2025/3.jpg",
        "/img/gallery/yogaday2025/4.jpg",
        "/img/gallery/yogaday2025/5.jpg",
        "/img/gallery/yogaday2025/6.jpg",
        "/img/gallery/yogaday2025/7.jpg",
        "/img/gallery/yogaday2025/8.jpg",
        "/img/gallery/yogaday2025/9.jpg",
        "/img/gallery/yogaday2025/10.jpg",
        "/img/gallery/yogaday2025/11.jpg",
        "/img/gallery/yogaday2025/12.jpg",
        "/img/gallery/yogaday2025/13.jpg",
        "/img/gallery/yogaday2025/14.jpg",
        "/img/gallery/yogaday2025/15.jpg",
        "/img/gallery/yogaday2025/16.jpg",
        "/img/gallery/yogaday2025/17.jpg",
        "/img/gallery/yogaday2025/18.jpg",
        "/img/gallery/yogaday2025/19.jpg",
        "/img/gallery/yogaday2025/20.jpg",
      ],
    },
    {
      title: "International Yoga Day 2024",
      images: [
        "/img/gallery/internationalyogaday2024/1.jpg",
        "/img/gallery/internationalyogaday2024/2.jpg",
        "/img/gallery/internationalyogaday2024/3.jpg",
        "/img/gallery/internationalyogaday2024/4.jpg",
        "/img/gallery/internationalyogaday2024/5.jpg",
        "/img/gallery/internationalyogaday2024/6.jpg",
        "/img/gallery/internationalyogaday2024/7.jpg",
        "/img/gallery/internationalyogaday2024/8.jpg",
        "/img/gallery/internationalyogaday2024/9.jpg",
        "/img/gallery/internationalyogaday2024/10.jpg",
        "/img/gallery/internationalyogaday2024/11.jpg",
        "/img/gallery/internationalyogaday2024/12.jpg",
        "/img/gallery/internationalyogaday2024/13.jpg",
        "/img/gallery/internationalyogaday2024/14.jpg",
      ],
    },
];

  return (
    <>
      <Helmet>
        <title>International Yoga Day | Gandhi Mandela Foundation</title>
      </Helmet>

      <Header />
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>International Yoga Day</span>
          </div>

          <h1>International Yoga Day</h1>
        </div>
      </section>
        
      <section className="gallery-section">
        <div className="container">
        
          {galleryYoga.map((section, sectionIndex) => (
            <div className="gallery-block" key={sectionIndex}>

              <h2 className="gallery-title">
                {section.title}
              </h2>
                {/* Sirf Yoga Day section me banner dikhega */}
                    {section.title === "Nelson Mandela Day" && (
                    <div
                        className="full-image-wrapper"
                        onClick={() =>
                            openGallery(
                            ["/img/gallery/GMF/1.jpg", ...section.images],
                            0
                            )
                        }
                        >
                        <img
                            src="/img/gallery/GMF/1.jpg"
                            alt="Nobel Prize winner Rigoberta Menchú Tum conferred with Gandhi Mandela Award 2020"
                            className="full-width-image"
                        />
                        <h4 align="center">
                            Nobel Prize winner Rigoberta Menchú Tum conferred with Gandhi Mandela Award 2020
                        </h4>
                    </div>
                    )}
              <div className="gallery-grid">

                {section.images.map((image, imageIndex) => (
                  <div
                    key={imageIndex}
                    className="gallery-card"
                    onClick={() =>
                      openGallery(section.images, imageIndex)
                    }
                  >
                    <img
                      src={image}
                      alt={`${section.title} ${imageIndex + 1}`}
                    />
                  </div>
                ))}

              </div>

            </div>
          ))}

        </div>
      </section>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        plugins={[Zoom, Thumbnails, Counter]}
      />
      <Footer />
    </>
  );
}
